<template>
    <b-modal
        body-class="p-0"
        v-model="modalSchedule"
        no-close-on-backdrop
        @close="modalSchedule = false"
        size="xl"
        class="create-booking-modal"
        id="modal-select-schedule-new"
        :title="'Select Your Best Schedule'"
        :hide-footer="true"
    >
        <b-row class="pt-2 px-2">
            <b-col cols="12">
                <vue-good-table
                    @on-row-click="onRowClick"
                    v-if="fields.length > 0"
                    :columns="fields"
                    :rows="schedule_list"
                    :sort-options="{
                        enabled: false,
                    }"
                >
                    <template slot="table-row" slot-scope="props">
                        <!-- Column: Action -->

                        <span v-if="props.column.label === 'Action'">
                            <b-button
                                variant="primary"
                                size="sm"
                                @click="modalShow = !modalShow"
                            >
                                Select
                            </b-button>
                        </span>
                        <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                    </template>
                </vue-good-table>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
import ClickOutside from "vue-click-outside";
import useJwt from "@/auth/jwt/useJwt";

export default {
    directives: {
        ClickOutside,
    },

    props: {
        value: { type: false },
        options: {
            type: Object,
            required: true,
        },
    },
    computed: {
        modalSchedule: {
            get: function () {
                return this.value;
            },
            set: function (value) {
                this.$emit("input", value);
            },
        },
    },
    data() {
        return {
            fields: [],
            fields_all: {
                AIR: [
                    {
                        label: "POL",
                        thClass: "text-uppercase align-middle",
                        field: "pol",
                        tdClass: "align-middle text-center",

                        filterOptions: {
                            enabled: false,
                            placeholder: "POL",
                        },
                    },
                    {
                        label: "POD",
                        field: "pod",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "POD",
                        },
                    },
                    {
                        label: "LINE",
                        thClass: "text-uppercase align-middle",
                        field: "carrier",
                        tdClass: "align-middle text-center",

                        filterOptions: {
                            enabled: false,
                            placeholder: "CARRIER",
                        },
                    },
                    {
                        label: "ETD",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "etd",
                        filterOptions: {
                            enabled: false,
                            placeholder: "ETD",
                        },
                    },
                    {
                        label: "ETA",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "eta",
                        filterOptions: {
                            enabled: false,
                            placeholder: "ETD",
                        },
                    },
                    {
                        label: "TRANSIT TIME",
                        tdClass: "align-middle text-center",

                        field: "transit_time",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "TRANSIT TIME",
                        },
                    },
                    {
                        label: "CARGO CUT OFF",
                        tdClass: "align-middle text-center",

                        field: "cargo_cut_off",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "CARGO CUT OFF",
                        },
                    },
                    {
                        label: "DOC CUT OFF",
                        tdClass: "align-middle ",

                        field: "doc_cut_off",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "DOC CUT OFF",
                        },
                    },
                    {
                        label: "TRANSIT PORT",
                        tdClass: "align-middle text-center",

                        field: "transit",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "TRANSIT PORT",
                        },
                    },
                ],
                LCL: [
                    {
                        label: "POL",
                        thClass: "text-uppercase align-middle",
                        field: "pol",
                        tdClass: "align-middle text-center",

                        filterOptions: {
                            enabled: false,
                            placeholder: "POL",
                        },
                    },
                    {
                        label: "POD",
                        field: "pod",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "POD",
                        },
                    },
                    {
                        label: "LINE",
                        thClass: "text-uppercase align-middle",
                        field: "carrier",
                        tdClass: "align-middle text-center",

                        filterOptions: {
                            enabled: false,
                            placeholder: "CARRIER",
                        },
                    },
                    {
                        label: "ETD",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "etd",
                        filterOptions: {
                            enabled: false,
                            placeholder: "ETD",
                        },
                    },
                    {
                        label: "ETA",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "eta",
                        filterOptions: {
                            enabled: false,
                            placeholder: "ETA",
                        },
                    },
                    {
                        label: "TRANSIT TIME",
                        tdClass: "align-middle text-center",

                        field: "transit_time",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "TRANSIT TIME",
                        },
                    },

                    {
                        label: "CARGO CUT OFF",
                        tdClass: "align-middle text-center",

                        field: "cargo_cut_off",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "CARGO CUT OFF",
                        },
                    },
                    {
                        label: "DOC CUT OFF",
                        tdClass: "align-middle text-center",

                        field: "doc_cut_off",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "DOC CUT OFF",
                        },
                    },
                    {
                        label: "TRANSIT PORT",
                        tdClass: "align-middle text-center",

                        field: "transit",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "TRANSIT PORT",
                        },
                    },
                ],
                FCL: [
                    {
                        label: "POL",
                        thClass: "text-uppercase align-middle",
                        field: "pol",
                        tdClass: "align-middle text-center",

                        filterOptions: {
                            enabled: false,
                            placeholder: "POL",
                        },
                    },
                    {
                        label: "POD",
                        field: "pod",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "POD",
                        },
                    },
                    {
                        label: "LINE",
                        thClass: "text-uppercase align-middle",
                        field: "carrier",
                        tdClass: "align-middle text-center",

                        filterOptions: {
                            enabled: false,
                            placeholder: "CARRIER",
                        },
                    },
                    {
                        label: "ETD",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "etd",
                        filterOptions: {
                            enabled: false,
                            placeholder: "ETD",
                        },
                    },
                    {
                        label: "ETA",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "eta",
                        filterOptions: {
                            enabled: false,
                            placeholder: "ETA",
                        },
                    },
                    {
                        label: "TRANSIT TIME",
                        tdClass: "align-middle text-center",

                        field: "transit_time",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "TRANSIT TIME",
                        },
                    },
                    {
                        label: "CARGO CUT OFF",
                        tdClass: "align-middle text-center",

                        field: "cargo_cut_off",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "CARGO CUT OFF",
                        },
                    },
                    {
                        label: "DOC CUT OFF",
                        tdClass: "align-middle text-center",

                        field: "doc_cut_off",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "DOC CUT OFF",
                        },
                    },
                    {
                        label: "TRANSIT PORT",
                        tdClass: "align-middle text-center",

                        field: "transit",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "TRANSIT PORT",
                        },
                    },
                ],
                FTL: [
                    {
                        label: "POL",
                        thClass: "text-uppercase align-middle",
                        field: "pol",
                        tdClass: "align-middle text-center",

                        filterOptions: {
                            enabled: false,
                            placeholder: "POL",
                        },
                    },
                    {
                        label: "POD",
                        field: "pod",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "POD",
                        },
                    },
                    {
                        label: "ETD",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "etd",
                        filterOptions: {
                            enabled: false,
                            placeholder: "ETD",
                        },
                    },
                    {
                        label: "ETA",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "eta",
                        filterOptions: {
                            enabled: false,
                            placeholder: "ETA",
                        },
                    },
                    {
                        label: "TRANSIT TIME",
                        tdClass: "align-middle text-center",

                        field: "transit_time",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "TRANSIT TIME",
                        },
                    },
                    {
                        label: "CARGO CUT OFF",
                        tdClass: "align-middle text-center",

                        field: "cargo_cut_off",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "CARGO CUT OFF",
                        },
                    },
                    {
                        label: "DOC CUT OFF",
                        tdClass: "align-middle text-center",

                        field: "doc_cut_off",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "DOC CUT OFF",
                        },
                    },
                    {
                        label: "TRANSIT PORT",
                        tdClass: "align-middle text-center",

                        field: "transit",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "TRANSIT PORT",
                        },
                    },
                ],
                SEA_LTL: [
                    {
                        label: "POL",
                        thClass: "text-uppercase align-middle",
                        field: "pol",
                        tdClass: "align-middle text-center",

                        filterOptions: {
                            enabled: false,
                            placeholder: "POL",
                        },
                    },
                    {
                        label: "POD",
                        field: "pod",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "POD",
                        },
                    },
                    {
                        label: "ETD",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "etd",
                        filterOptions: {
                            enabled: false,
                            placeholder: "ETD",
                        },
                    },
                    {
                        label: "ETA",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "eta",
                        filterOptions: {
                            enabled: false,
                            placeholder: "ETA",
                        },
                    },
                    {
                        label: "Transit time",
                        tdClass: "align-middle text-center",

                        field: "transit_time",
                        thClass: " align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "Transit time",
                        },
                    },
                    {
                        label: "Carrier",
                        tdClass: "align-middle text-center",

                        thClass: " align-middle",
                        field: "Carrier",
                        filterOptions: {
                            enabled: false,
                            placeholder: "Carrier",
                        },
                    },

                    {
                        label: "Vessel/Voyage",
                        tdClass: "align-middle text-center",

                        thClass: " align-middle",
                        field: "vessel_name",
                        filterOptions: {
                            enabled: false,
                            placeholder: "Vessel/Voyage",
                        },
                    },

                    {
                        label: "Transit/Direct",
                        tdClass: "align-middle text-center",

                        field: "transit_code",
                        thClass: " align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "Transit/Direct",
                        },
                    },
                    {
                        label: "Cargo closing time",
                        tdClass: "align-middle text-center",

                        field: "cargo_cut_off",
                        thClass: " align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "Cargo closing time",
                        },
                    },
                    {
                        label: "Doc closing time",
                        tdClass: "align-middle text-center",

                        field: "doc_cut_off",
                        thClass: " align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "Doc closing time",
                        },
                    },
                    {
                        label: "Stuffing place",
                        tdClass: "align-middle text-center",

                        thClass: " align-middle",
                        field: "stuffing_place",
                        width: "200px",
                        filterOptions: {
                            enabled: false,
                            placeholder: "Stuffing place",
                        },
                    },
                    {
                        label: "Action",
                        tdClass: "align-middle text-center",

                        thClass: " align-middle",
                        field: "Select",
                        width: "200px",
                        filterOptions: {
                            enabled: false,
                            placeholder: "Action",
                        },
                    },
                ],
                LTL: [
                    {
                        label: "POL",
                        thClass: "text-uppercase align-middle",
                        field: "pol",
                        tdClass: "align-middle text-center",

                        filterOptions: {
                            enabled: false,
                            placeholder: "POL",
                        },
                    },
                    {
                        label: "POD",
                        field: "pod",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "POD",
                        },
                    },
                    {
                        label: "ETD",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "etd",
                        filterOptions: {
                            enabled: false,
                            placeholder: "ETD",
                        },
                    },
                    {
                        label: "ETA",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "eta",
                        filterOptions: {
                            enabled: false,
                            placeholder: "ETA",
                        },
                    },
                    {
                        label: "TRANSIT TIME",
                        tdClass: "align-middle text-center",

                        field: "transit_time",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "TRANSIT TIME",
                        },
                    },
                    {
                        label: "CARGO CUT OFF",
                        tdClass: "align-middle text-center",

                        field: "cargo_cut_off",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "CARGO CUT OFF",
                        },
                    },
                    {
                        label: "DOC CUT OFF",
                        tdClass: "align-middle text-center",

                        field: "doc_cut_off",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "DOC CUT OFF",
                        },
                    },
                    {
                        label: "STUFFING PLACE",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "stuffing_place",
                        width: "200px",
                        filterOptions: {
                            enabled: false,
                            placeholder: "STUFFING PLACE",
                        },
                    },
                ],
                SEA_FCL: [
                    {
                        label: "POL",
                        thClass: "text-uppercase align-middle",
                        field: "pol",
                        tdClass: "align-middle text-center",

                        filterOptions: {
                            enabled: false,
                            placeholder: "POL",
                        },
                    },
                    {
                        label: "POD",
                        field: "pod",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "POD",
                        },
                    },
                    {
                        label: "ETD",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "etd",
                        filterOptions: {
                            enabled: false,
                            placeholder: "ETD",
                        },
                    },
                    {
                        label: "ETA",
                        tdClass: "align-middle text-center",

                        thClass: "text-uppercase align-middle",
                        field: "eta",
                        filterOptions: {
                            enabled: false,
                            placeholder: "ETA",
                        },
                    },
                    {
                        label: "TRANSIT TIME",
                        tdClass: "align-middle text-center",

                        field: "transit_time",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "TRANSIT TIME",
                        },
                    },
                    {
                        label: "CARGO CUT OFF",
                        tdClass: "align-middle text-center",

                        field: "cargo_cut_off",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "CARGO CUT OFF",
                        },
                    },
                    {
                        label: "DOC CUT OFF",
                        tdClass: "align-middle text-center",

                        field: "doc_cut_off",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "DOC CUT OFF",
                        },
                    },
                    {
                        label: "TRANSIT PORT",
                        tdClass: "align-middle text-center",

                        field: "transit",
                        thClass: "text-uppercase align-middle",

                        filterOptions: {
                            enabled: false,
                            placeholder: "TRANSIT PORT",
                        },
                    },
                ],
            },
            constantsType: {
                LCL: "LCL",
                FCL: "FCL",
                FTL: "Container Trucking",
                LTL: "Van Trucking",
                AIR: "AIR",
            },
            schedule_list: [],
        };
    },

    mounted() {
        this.$loading.show();
        setTimeout(() => {
            this.getSchedule();
        }, 500);
    },

    methods: {
        onRowClick(payload) {
            this.$emit("select", payload.row);
        },
        async getSchedule() {
            if (this.options.service == "AIR") {
                this.fields = this.fields_all.AIR;
            } else if (this.options.service == "LCL") {
                this.fields = this.fields_all.SEA_LTL;
            } else if (this.options.service == "FCL") {
                this.fields = this.fields_all.FCL;
            } else if (this.options.service == "FTL") {
                this.fields = this.fields_all.FTL;
            } else if (this.options.service == "LTL") {
                this.fields = this.fields_all.LTL;
            }

            useJwt
                .get(`scheduleList`, {
                    params: {
                        search: {
                            service_type: this.options.service,
                            eta: this.options.eta,
                            etd: this.options.etd,
                            pol:
                                this.options.pol != ""
                                    ? this.options.pol_name
                                    : "",
                            pod:
                                this.options.pod != ""
                                    ? this.options.pod_name
                                    : "",
                            cargo_ready: this.options.cargo_ready,
                            from_date: this.options.from_date,
                            to_date: this.options.to_date,
                        },
                        page: 1,
                        pageSize: 10000000,
                    },
                })
                .then((response) => {
                    const data = response.data.result;
                    if (!!this.userData) {
                        /*this.fields.push({
              key: "actions",
              label: "Actions",
              class: "text-center",
            });*/
                        const mapData = data.map((obj) => {
                            obj.actions = "/admin/find-a-quotation";
                            return obj;
                        });

                        this.schedule_list = mapData;
                        return;
                    }
                    this.schedule_list = data;
                })
                .finally(() => this.$loading.hide());
        },
    },
};
</script>

<style lang="scss"></style>
